import React from "react";

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EditableTable from "../../../components/tables/EditableTable";
import LoadingGif from "../../../components/visual/LoadingGif";

import { Box, Divider, Grid, IconButton, Modal, Typography } from "@mui/material";
import { defaultRequest } from "../../../utils/request/request";


class UserRepresentativePopup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoadingRepresentative: true,
            isLoadingRepresentativeTable: true,

            representativeList: [],
            representativeColumns: [
                ['nome', 'Nome'],
                ['sobrenome', 'Sobrenome'],
                ['telcelular', 'celular'],
                ['email', 'Email'],
            ],
            representativeTotalSize: '',
        }
    }

    componentDidMount() {
        this.searchRepresentative()
    }

    searchRepresentative = () => {
        let config = {
            method: 'get',
            endpoint: 'represented/user'
        }
        let form = {
            id: this.props.represented.idrepresentada,
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.setState({
                    representativeList: r.data.representedUser,
                    representativeTotalSize: r.data.representedUser.length,

                    isLoadingRepresentative: false,
                    isLoadingRepresentativeTable: false
                })
            } else {
                this.props.showAlert(r.data.message, 'error')
                this.setState({
                    isLoadingRepresentative: false,
                    isLoadingRepresentativeTable: false
                })
            }
        })
    }


    render() {
        if (this.state.isLoadingRepresentative) {
            return (
                <Modal open={this.props.isOpen} onClose={this.props.closePopup} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box style={styles.popUpContainer}>
                        <LoadingGif />
                    </Box>
                </Modal>
            )
        }
        return (
            <Modal open={this.props.isOpen} onClose={this.props.closePopup} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box style={styles.popUpContainer}>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography>Visualizar Representantes</Typography>
                        <IconButton onClick={this.props.closePopup}>
                            <CloseOutlinedIcon />
                        </IconButton>
                    </Box>

                    <Grid item md={12}><Divider /></Grid>

                    <Grid container columnSpacing={1} rowSpacing={4} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>

                        <Grid item md={12}>
                            <EditableTable
                                {...this.props}
                                height='35vh'
                                customMargin='10px 0 0 0'
                                id='idusuario'
                                data={this.state.representativeList}
                                columns={this.state.representativeColumns}
                                rowId='idusuario'
                                totalSize={this.state.representativeTotalSize}
                                onPageChange={() => { }}
                                onEditRow={() => { }}
                                onRowDoubleClick={() => { }}
                                isLoading={this.state.isLoadingRepresentedRegionTable}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        )
    }
}

export default UserRepresentativePopup;

const styles = {
    popUpContainer: {
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '20px',
        width: '80%',
        height: '50vh',
        maxWidth: '900px',
        maxHeight: '90vh',
        overflowY: 'auto',
    },
}